/* LUME science scroll (updated 19 Oct 2026 for speed: the soft glow behind the steps is drawn at screen
   resolution and about 30 times a second, so phones scroll smoothly) */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (document.documentElement.dataset.lumeAnim === 'off') return;

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  const MINDMAP = [
    {
      step: 'Step 01 | The Spectrum',
      title: 'Frequency Selection',
      text: 'Each Key begins with a single color of light. We choose one wavelength, such as red, green, yellow, or blue, to shape the entire product. Choosing this light wavelength is the first step in our process called photon induced modulation.',
      chips: ['644nm · red', '538nm · green', '580nm · amber', '453.5nm · blue'],
      color: '#E06A5A',
    },
    {
      step: 'Step 02 | The Craft',
      title: '41-Day Light Induction',
      text: 'Pure flaxseed oil rests under targeted light for 41 days straight at a fixed 45 degree angle. This simple process uses only pure oil, steady light, and patience.',
      chips: ['41 days', '45° angle', 'continuous light', 'single wavelength'],
      color: '#F1C15D',
    },
    {
      step: 'Step 03 | The Protocol',
      title: 'The Five-Minute Application',
      text: 'Put two to three drops on your skin and rub in Anti-clockwise circles for five minutes. Repeat this process daily, once or twice a day. Daily use gives you the best outcome.',
      chips: ['2–3 drops', '5 minutes', 'anti-clockwise', 'daily'],
      color: '#6FCF97',
    },
  ];

  const ROMAN = ['I', 'II', 'III'];
  const sc = $('#scrolly');
  const stage = $('#scrollyStage');
  if (!sc || !stage) return;

  let step = -1;
  let p = 0;
  let swapToken = 0;
  let visible = false;
  let raf = null;

  const setChips = (chips) => {
    const box = $('#stChips');
    if (!box) return;
    while (box.firstChild) box.removeChild(box.firstChild);
    chips.forEach((x) => {
      const span = document.createElement('span');
      span.className = 'ed-datum';
      span.textContent = x;
      box.appendChild(span);
    });
  };

  const setTitle = (title) => {
    const el = $('#stTitle');
    if (!el) return;
    const words = title.split(' ');
    const last = words.pop();
    while (el.firstChild) el.removeChild(el.firstChild);
    if (words.length) el.appendChild(document.createTextNode(words.join(' ') + ' '));
    const em = document.createElement('em');
    em.textContent = last;
    el.appendChild(em);
  };

  const setStep = (i) => {
    if (i === step) return;
    step = i;
    const m = MINDMAP[i];
    const c = m.color;
    const token = ++swapToken;
    $$('.ed-num').forEach((d, j) => d.classList.toggle('active', j === i));
    for (let j = 0; j < 3; j++) {
      const line = $('#cl' + j);
      const dot = $('#cd' + j);
      const on = j === i;
      if (line) line.style.stroke = on ? c : '';
      if (dot) {
        dot.style.fill = on ? c : '';
        dot.setAttribute('r', on ? 4.5 : 3);
      }
    }
    const g = $('#stGroup');
    if (!g) return;
    g.classList.add('out');
    setTimeout(() => {
      if (token !== swapToken) return;
      const stStep = $('#stStep');
      if (stStep) {
        stStep.textContent = m.step;
        stStep.style.color = c;
      }
      setTitle(m.title);
      g.style.setProperty('--edc', c);
      stage.style.setProperty('--edc', c);
      const stText = $('#stText');
      if (stText) stText.textContent = m.text;
      setChips(m.chips);
      const ghost = $('#stGhost');
      if (ghost) ghost.textContent = ROMAN[i];
      g.classList.remove('out');
    }, 340);
  };

  // Sync rail buttons too
  $$('.ed-num').forEach((btn) => {
    btn.addEventListener('click', () => {
      const i = Number(btn.dataset.st || 0);
      setStep(i);
      // jump scroll into the corresponding third of the chapter
      const total = sc.offsetHeight - stage.offsetHeight;
      if (total > 0) {
        const top = sc.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: top + (total * i) / 2, behavior: 'smooth' });
      }
    });
  });

  const cv = $('#fxCanvas');
  const ctx = cv ? cv.getContext('2d') : null;
  const GOLD = [241, 193, 93];
  let cur = [...GOLD];
  const P = Array.from({ length: 46 }, () => ({
    a: Math.random() * Math.PI * 2,
    r: 0.25 + Math.random() * 0.75,
    s: 0.0006 + Math.random() * 0.0014,
    sz: 0.5 + Math.random() * 1.3,
  }));

  const hex2rgb = (h) => [
    parseInt(h.slice(1, 3), 16),
    parseInt(h.slice(3, 5), 16),
    parseInt(h.slice(5, 7), 16),
  ];

  /* The glow is soft, so it is drawn at screen resolution (not 2-3x on phones) and about 30 times a second */
  const FX_DPR = 1;
  let fxLast = 0;
  const fxSize = () => {
    if (!cv) return;
    cv.width = Math.round(cv.offsetWidth * FX_DPR);
    cv.height = Math.round(cv.offsetHeight * FX_DPR);
  };
  if (cv) {
    fxSize();
    addEventListener('resize', fxSize);
  }

  const tick = (now) => {
    const total = sc.offsetHeight - stage.offsetHeight;
    if (total > 0) {
      const r = sc.getBoundingClientRect();
      p = Math.min(1, Math.max(0, -r.top / total));
    }
    setStep(Math.min(2, Math.round(p * 2)));
    const ghost = $('#stGhost');
    if (ghost) ghost.style.transform = `translate(-50%,-56%) scale(${(1 + p * 0.05).toFixed(3)})`;

    if (ctx && cv && visible && (!now || now - fxLast >= 33)) {
      fxLast = now || 0;
      const W = cv.width;
      const H = cv.height;
      const cx = W * 0.5;
      const cy = H * 0.5;
      const stc = hex2rgb(MINDMAP[Math.max(0, step)].color);
      const tgt = GOLD.map((g, i) => g * 0.55 + stc[i] * 0.45);
      cur = cur.map((v, i) => v + (tgt[i] - v) * 0.08);
      ctx.clearRect(0, 0, W, H);
      const g = ctx.createRadialGradient(cx, cy, 0, cx, cy, Math.max(W, H) * 0.55);
      g.addColorStop(0, `rgba(${cur.map(Math.round).join(',')},.09)`);
      g.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, W, H);
      const maxR = Math.max(W, H) * 0.5;
      P.forEach((pt) => {
        pt.r -= pt.s * 2;
        if (pt.r < 0.07) pt.r = 1;
        const x = cx + Math.cos(pt.a) * pt.r * maxR;
        const y = cy + Math.sin(pt.a) * pt.r * maxR * 0.7;
        ctx.beginPath();
        ctx.arc(x, y, pt.sz * FX_DPR, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(${cur.map(Math.round).join(',')},${0.25 + (1 - pt.r) * 0.45})`;
        ctx.fill();
      });
    }
    if (visible) raf = requestAnimationFrame(tick);
  };

  new IntersectionObserver(
    ([e]) => {
      visible = e.isIntersecting;
      if (visible) {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(tick);
      }
    },
    { threshold: 0.05 }
  ).observe(sc);

  setStep(0);
})();